import { useAppDispatch } from '@hooks/reduxHooks.ts';
import { useEffectOnce } from '@hooks/useEffectOnce.ts';
import { useFrontErrorLogger } from '@hooks/useFrontErrorLogger.ts';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import NotificationProvider from '@providers/NotificationProvider.tsx';
import { AppRouter } from '@router/router';
import { getClientStatus } from '@shared/model/clientStatus.slice.ts';
import { activateLocale, pickInitialLocale } from '@utils/i18n.ts';

import './App.css';

function App() {
    const dispatch = useAppDispatch();

    // load “session-static” data once and keep them in redux for non-logged-in/logged-in user
    useEffectOnce(() => {
        const initialLocale = pickInitialLocale();
        // Load + activate before app logic that might translate
        activateLocale(initialLocale).then(() => {
            void dispatch(getClientStatus());
        });
    }, true);

    useFrontErrorLogger();

    return (
        // key forces a re-mount when locale changes so children pick up new messages
        <I18nProvider i18n={i18n} key={i18n.locale}>
            <NotificationProvider>
                <AppRouter />
            </NotificationProvider>
        </I18nProvider>
    );
}

export default App;
